import { render, staticRenderFns } from "./open_jobs.vue?vue&type=template&id=56b52264&scoped=true&"
import script from "./open_jobs.vue?vue&type=script&lang=js&"
export * from "./open_jobs.vue?vue&type=script&lang=js&"
import style0 from "./open_jobs.vue?vue&type=style&index=0&id=56b52264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b52264",
  null
  
)

export default component.exports